import {useState} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {format} from 'date-fns'
import {updateTicketSolution} from '../../../api'

function RaiseticketsCardsModal({selectedTask, closeModal, updateTaskStatus}) {
  const [formData, setFormData] = useState({
    status: selectedTask.status,
    solution: selectedTask.solution || '',
  })

  const [fullScreenImage, setFullScreenImage] = useState<string | null>(null)
  const [isPosting, setIsPosting] = useState(false)

  const handleStatusChange = async (e) => {
    const newStatus = e.target.value;
    setFormData({...formData, status: newStatus});
  
    try {
      await updateTicketSolution(selectedTask.ticket_id, newStatus, formData.solution);
      updateTaskStatus(selectedTask.ticket_id, newStatus); // Move the card in UI after success
    } catch (error) {
      alert("Failed to update status. Please try again.");
    }
  };

  const handleSolutionChange = (e) => {
    setFormData({...formData, solution: e.target.value})
  }

  const handlePostSolution = async () => {
    if (!formData.solution.trim()) {
      alert('Solution cannot be empty')
      return
    }

    setIsPosting(true)
    try {
      await updateTicketSolution(selectedTask.ticket_id, formData.status, formData.solution)
      alert('Solution posted successfully')
      closeModal() // Close the modal after posting
    } catch (error) {
      alert('Failed to update solution. Please try again.')
    } finally {
      setIsPosting(false)
    }
  }

  return (
    <div className='modal fade show d-block' tabIndex={-1} role='dialog'>
      <div className='modal-dialog' role='document' style={{marginTop: '10rem'}}>
        <div className='modal-content'>
          {/* Modal Header */}
          <div className='modal-header'>
            <div>
              <select
                className='form-select form-select-solid'
                value={formData.status}
                onChange={handleStatusChange}
                style={{
                  backgroundColor: '#e6e6e6',
                  border: 'none',
                  appearance: 'none',
                  cursor: 'pointer',
                }}
              >
                <option value='open'>Open</option>
                <option value='In Progress'>In Progress</option>
                <option value='resolved'>Resolved</option>
              </select>
            </div>
            <button className='btn btn-icon btn-sm btn-active-secondary' onClick={closeModal}>
              <KTSVG
                path='media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </button>
          </div>

          {/* Modal Body */}
          <div
            className='modal-body'
            style={{maxHeight: '50vh', overflowY: 'auto', padding: '10px'}}
          >
            <p>
              <strong>{selectedTask.title}</strong>
            </p>
            <p>{selectedTask.description}</p>
            <p>
              <strong>Ticket ID:&nbsp;</strong> {selectedTask.ticket_id}
            </p>
            <p>
              <strong>Issue Type:&nbsp;</strong>
              <span
                className={`badge ${
                selectedTask.issue === 'task'
                    ? 'badge-light-primary'
                    : selectedTask.issue === 'bug'
                    ? 'badge-light-danger'
                    : selectedTask.issue === 'other'
                    ? 'badge-light-warning'
                    : 'badge-light-success'
                }`}
              >
                {selectedTask.issue}
              </span>
            </p>
            <p>
              <strong>Ticket Created:&nbsp;</strong>{' '}
              {format(new Date(selectedTask.created_at), 'dd-MMM-yyyy')}
            </p>
          </div>

          {/* Modal Footer */}
          <div
            className='modal-footer'
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'stretch',
              padding: '10px',
            }}
          >
            {/* Attachments Section */}
            <div className='form-group'>
              <label>Attachments</label>
              {selectedTask.attachments && selectedTask.attachments.length > 0 ? (
                <div className='d-flex flex-wrap gap-2'>
                  {selectedTask.attachments.map((attachment, index) => (
                    <div key={index} className='attachment-item'>
                      {attachment.endsWith('.pdf') ? (
                        <a
                          href={attachment}
                          target='_blank'
                          rel='noopener noreferrer'
                          className='btn btn-primary'
                        >
                          View PDF
                        </a>
                      ) : (
                        <img
                          src={attachment}
                          alt={`Attachment ${index + 1}`}
                          className='img-thumbnail'
                          style={{width: '100px', height: '100px', cursor: 'pointer'}}
                          onClick={() => setFullScreenImage(attachment)}
                        />
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <p>No attachments available</p>
              )}
            </div>

            {/* Solution Section */}
            <div className='form-group mt-3'>
              <label>Write Solution</label>
              <textarea
                className='form-control'
                value={formData.solution}
                onChange={handleSolutionChange}
                disabled={!!selectedTask.solution}
                style={{
                  backgroundColor: selectedTask.solution ? '#f0f0f0' : 'white',
                  color: selectedTask.solution ? '#555' : '#000',
                  cursor: selectedTask.solution ? 'not-allowed' : 'text',
                }}
              ></textarea>
            </div>

            {/* Post Solution Button */}
            {!selectedTask.solution && (
              <button
                type='button'
                className='btn'
                style={{
                  backgroundColor: '#6D9300',
                  color: 'white',
                  padding: '10px',
                  marginTop: '10px',
                }}
                onClick={handlePostSolution}
                disabled={isPosting}
              >
                {isPosting ? 'Posting...' : 'Post Solution'}
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Full-Screen Image Viewer */}
      {fullScreenImage && (
        <div
          className='full-screen-overlay'
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1050,
          }}
          onClick={() => setFullScreenImage(null)}
        >
          <img
            src={fullScreenImage}
            alt='Full Screen'
            style={{maxWidth: '90%', maxHeight: '90%'}}
          />
          <button
            className='btn btn-danger'
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              fontSize: '18px',
              padding: '10px',
            }}
            onClick={() => setFullScreenImage(null)}
          >
            Close
          </button>
        </div>
      )}
    </div>
  )
}

export default RaiseticketsCardsModal
